import createLoggerMiddleware from 'redux-logger';

export const appendLoggerMiddlewareInDev = middlewares => {
  if (process.env.NODE_ENV !== 'production') {
    const loggerMiddleware = createLoggerMiddleware({
      collapsed: (getState, action) => action.type.indexOf('redux-form/') > -1,
    });

    middlewares.push(loggerMiddleware);
  }
};



// WEBPACK FOOTER //
// ./src/utils/redux/index.js